var exports = {
  "qr": "xe30f6088--77246c--footer",
  "Bd": "xe30f6088--77246c--footer-mobile",
  "tP": "xe30f6088--77246c--footer-adaptive",
};

module.exports = exports;
